import type { ReactNode } from 'react'
import { MarketingContentFrame } from '@/landing/marketing-content-frame'
import { cn } from '@/lib/utils'

type MarketingSectionProps = {
  id?: string
  children: ReactNode
  variant?: 'default' | 'cream'
  className?: string
  innerClassName?: string
}

export function MarketingSection({
  id,
  children,
  variant = 'default',
  className,
  innerClassName,
}: MarketingSectionProps) {
  return (
    <section
      id={id}
      className={cn(
        'py-16 sm:py-20 lg:py-24',
        variant === 'cream' && 'bg-[var(--marketing-surface-cream,#f5f1e8)]',
        className
      )}
    >
      <MarketingContentFrame className={innerClassName}>{children}</MarketingContentFrame>
    </section>
  )
}
